export default __webpack_public_path__ + "static/media/copyleft-pirate.2ba65720.svg";